import React from 'react';

import { Radio as AntRadio } from 'antd';

export interface RadioProps {
  size?: any;
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  defaultValue?: string | number;
  onChange?: any;
  children: React.ReactNode;
  value?: any;
}

const Radio: React.FC<RadioProps> = (props) => {
  return <AntRadio.Group {...props}>{props.children}</AntRadio.Group>;
};

export default Radio;
